const focusTestTypes = ['focus_test_settings', 'offline_focus_test_sections'];

// eslint-disable-next-line import/prefer-default-export
export const isNotFocusTest = ({ relationships: { source } }) =>
  !focusTestTypes.includes(source.data.type);
